export default __webpack_public_path__ + "media/AiStudio.c6f8ec2f.svg";